import zwitCore from "./config/http";
import axios from "axios";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";
// 测试环境3.2接口可以无限提交签约的参数
const test = process.env.NODE_ENV === "development" ? "?test=true" : "";

const pendingMap = new Map(); // 请求停止队列
const removePending = (key) => {
  const cancel = pendingMap.get(key);
  if (cancel) {
    cancel();
    pendingMap.delete(key);
  }
};

export default {
  serveSignUplod(data, key) {
    // 中断正在上传同一个图片的接口
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    removePending(key);
    pendingMap.set(key, () => source.cancel("不想请求了"));

    return new Promise((resolve, reject) => {
      axios
        .post(BASE_URL + "/zw-user/selfContractNmrs/nf/uploadImg", data, {
          headers: { "Content-Type": "multipart/form-data" },
          cancelToken: source.token,
        })
        .then(
          (response) => {
            let result = response.data;
            if (result.resultCode == 200) {
              resolve(result);
            } else {
              reject(result);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  },
  // 获取国籍接口
  getNation(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/yinLianArea/nf/findNationality",
      params,
      false
    );
  },
  // 自助签约省市区接口
  getArea(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/yinLianArea/nf/find",
      params,
      false
    );
  },
  // 自助签约行业接口
  getProfession(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/yinLianIndustry/nf/find",
      params,
      false
    );
  },
  // 所属支行查询接口
  getBankList(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/dataSupport/nf/branchBankList",
      params,
      false
    );
  },
  // 上传默认图片
  uploadDefaultImg(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/selfContractNmrs/nf/uploadDefaultImg",
      params,
      false
    );
  },
  // 详细采集档案资料上传接口
  complexUploadBasic(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + `/zw-user/selfContractNmrs/nf/complexUploadBasic${test}`,
      params,
      false
    );
  },
  // 发起对公账户验证交易接口
  requestAccountVerify(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/corporateAccount/nf/requestAccountVerify",
      params,
      false
    );
  },
  // 前台签约接口
  agreementSign(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + `/zw-user/selfContractNmrs/nf/agreementSign${test}`,
      params,
      false
    );
  },
  // 获取当前签约进度
  signProgress(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/contractInfo/nf/lastDetail",
      params,
      false
    );
  },
  // 入网状态查询接口
  applyStatusQuery(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/selfContractNmrs/nf/networkAccessStatusQuery",
      params,
      false
    );
  },
  // 对公账户认证接口
  amountVerification(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/corporateAccount/nf/companyAccountVerify",
      params,
      false
    );
  },
  // 自助签约投审稿用户协议
  tsgSignServeAgreement(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/nf/businessTsg",
      params,
      false
    );
  },
  // 自助签约电商用户协议
  ZwSignServeAgreement(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/nf/businessZw",
      params,
      false
    );
  },
  // 获取填写过表单内容
  getFilledContent(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/selfContractNmrs/nf/getSelfContract",
      params,
      false
    );
  },
  // orc上传图片
  ocrUpload(params) {
    return zwitCore.HTTP.postFormData(
      BASE_URL + "/zw-public/ocr/upload",
      params,
      false
    );
  },
  // 提交合伙人申请
  partnerApply(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/partner/nf/apply",
      params,
      false
    );
  },
  // 网络图片下载返回file文件
  async imgToFileObj(url, fileName = "") {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], fileName, { type: "image/png" });
    // try {
    //     console.log(url,'url');

    //   // 第一步：使用axios获取网络图片数据
    //   const response = await axios.get(url, { responseType: "arraybuffer" });

    //   // 第二步：将图片数据转换为Blob对象
    //   const blob = new Blob([response.data], {
    //     type: response.headers["content-type"],
    //   });

    //   // 第三步：创建一个新的File对象
    //   const file = new File([blob], fileName, {
    //     type: response.headers["content-type"],
    //   });
    //   return file;
    // } catch (error) {
    //   console.error("将图片转换为File对象时发生错误:", error);
    //   throw error;
    // }
  },
  // 提交合伙人权益申请
  equityApply(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/partnerBusiness/nf/apply",
      params,
      false
    );
  },
};
